export enum Channels {
  ecommerce = 'ecommerce',
  mapp = 'mapp',
  selfLandingPage = 'selfLandingPage',
  changeCardPage = 'changeCardPage',
}
